var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnarchive = function SvgUnarchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.111 9.333a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H5.89a1 1 0 0 1-1-1v-8.667a1 1 0 0 1 1-1H18.11ZM10 14.031h1.523V16H9v-.5a.5.5 0 0 0-1 0v1l.01.1a.5.5 0 0 0 .49.4h7l.1-.01a.5.5 0 0 0 .4-.49v-1a.5.5 0 0 0-1 0v.5h-2.46v-1.969h1.524L12.031 12 10 14.031ZM19 4a1 1 0 0 1 1 1v1.556a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14Z",
    fill: "#262D38",
    fillOpacity: 0.3
  })));
};
export default SvgUnarchive;